<template>
  <div class="compressed-content">
    <h3>How much do you weight (in lbs)</h3>
    <v-form-group class="page-buttons" :validator="$v.weight" label="Weight">
      <b-form-input slot-scope="{ attrs, listeners }"
                    v-bind="attrs"
                    v-on="listeners"
                    v-model="survey.weight"
                    placeholder="Weight"
                    @click="e => e.target.setSelectionRange(0, e.target.value.length)" />
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required, between } from "vuelidate/lib/validators";

  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  import productType from 'enums/product-type';

  export default {
    mixins: [formMixin],

    data() {
      return {
        productType
      }
    },

    validations: {
      weight: {
        required,
        between: between(60, 600)
      }
    },

    computed: {
      ...mapState(["survey"]),

      weight() { return this.survey.weight; },
    }
  };
</script>